import psl_ui from '../../libs/psl_ui.js';
import {wait} from '../../libs/psl_polyfills.js';

import audio from '../../components/audio.js';
import instructions from '../../components/instructions/component.js';

import './style.scss';
import template from './template.pst';
import template_card from './card.pst';

psl_ui.templates.add('page_puzzle',template);
psl_ui.templates.add('page_puzzle_card',template_card);

const {el,rpoints}=psl_ui.templates.render('page_puzzle');

rpoints.finish.addEventListener('click',()=>{
	_ext.hide();
	if(_clb) _clb();
});

let _cards=[];

const _labels = [
	"Road, buildings, back half of a red automobile",
	"A row of buildings with grass in front",
	"Afarmhouse with a white picket fence",
	"Orange storage train car and left half of a red boxcar. Left half of a 'Stay off the Tracks' sign. bottom half of a red automobile",
	"Right half of a 'Stay off the Tracks' sign. Right half of a red boxcar and left half of a gray freight car",
	"Right half of a gray freight car, orange coal car, railroad crossing signal, top half of a green automobile",
	"Left half of bushes",
	"Right half of bushes",
	"Bottom half of a green automobile, road with 'railroad crossing' painted on it"
];

for(let i=0;i<9;i++){
	const card=psl_ui.templates.render('page_puzzle_card',{i:i.toString(),piece:i+1,label:_labels[i]}).el;
	card._index=i;
	card.addEventListener('click',()=>{
		_unblur(false);
		_click(card);
	});
	_cards.push(card);
}

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/900;
		height=height/1920;
	}

	coef = Math.min(width,height);

	rpoints.container.style.transform=`scale3d(${coef},${coef},1)`;
}

let _messages=[
	"Railroad tracks can be dangerous. They are not a setting for photos, not a place to hang out, and not a shortcut to school.",
	'When train accidents happen, they can result in very serious injuries.',
	'Only cross railroad tracks at official crossings',
	'Locomotives\' huge size make them look like they\'re moving slower than they are.',
	'Turn down your music at railroad crossings. Slowdown, look, listen, and be prepared to stop.',
	'There might be more than one train, and trains may be traveling in both directions.',
	'Trains always go first. Stay a safe distance away, and never stop your car or bicycle on train tracks.',
	'Never ignore a crossing signal or try to race a train.',
	'There are blue signs at every railroad crossing with a number to call in case of emergency. If you need help, look for the sign.'
];

let _messages_index = 0;

let _clb;

const _unblur = (v=true)=>{
	rpoints.game_board.classList.remove('blur');
	_cards.forEach(card=>{
		card.removeAttribute('tabindex');
		card.removeAttribute('aria-hidden');
	});
	if(v) _cards[0].focus();
	if(_messages_index===-1){
		_messages_index=0;
		_show_message();
	}
}

const init = (clb)=>{
	instructions.text='To unscramble the puzzle, choose two pieces to switch places. Then choose two more pieces to switch until all their pieces are in the correct place.';
	instructions.append(rpoints.container,_unblur);
	rpoints.game_board.classList.add('blur');

	rpoints.result.classList.add('hidden');
	rpoints.result.setAttribute('aria-hidden',"true");
	rpoints.finish.classList.add('hidden');
	rpoints.finish.setAttribute('tabindex','-1');
	rpoints.finish.setAttribute('aria-hidden',"true");
	rpoints.game_board.removeAttribute('aria-label');

	let any_correct;
	do{
		any_correct=false;
		_cards = _cards.sort(()=>(Math.random()-0.5));
		_cards.forEach((card,i)=>{
			if(card._index===i) any_correct=true;
		});
	} while(any_correct);

	_messages = _messages.sort(()=>(Math.random()-0.5));
	_messages_index = -1;

	_cards.forEach(card=>{
		card.setAttribute('aria-hidden','true');
		card.setAttribute('tabindex','-1');
		card.classList.remove('correct');
		rpoints.game_board.appendChild(card);
	});

	selected = undefined;

	_clb=clb;
}

let selected;
const _click = async card => {
	instructions.hide();

	if(card.classList.contains('selected')){
		selected = undefined;
		card.classList.remove('selected');
		return;
	}

	card.classList.add('selected');
	let prev = selected;
	if(prev){
		const selected_index = _cards.indexOf(prev);
		const card_index = _cards.indexOf(card);

		_cards[selected_index]=card;
		_cards[card_index]=prev;

		_cards.forEach(card=>{
			rpoints.game_board.appendChild(card);
		});

		let any_correct = false;

		if(card._index === _cards.indexOf(card)){
			card.setAttribute('tabindex','-1');
			card.setAttribute('aria-hidden', "true");
			card.classList.add('correct');
			any_correct = true;
		}

		if(prev._index === _cards.indexOf(prev)){
			prev.setAttribute('tabindex','-1');
			prev.setAttribute('aria-hidden', "true");
			prev.classList.add('correct');
			any_correct = true;
		}

		selected = undefined;

		if(any_correct){
			audio.play('correct');
			_show_message();
		} else {
			audio.play('suction_puzzle');
		}

		await wait(250);

		card.classList.remove('selected');
		prev.classList.remove('selected');

	} else {
		selected = card;
		audio.play('suction_puzzle');
		return;
	}

	let _correct = true;

	_cards.forEach((card,i)=>{
		if(card._index!==i) _correct=false;
	});

	if(_correct){
		audio.play('finished');
		_cards.forEach(card=>{
			card.setAttribute('tabindex','-1');
			card.setAttribute('aria-hidden', "true");
			card.classList.add('correct');
		});

		rpoints.finish.classList.remove('hidden');
		rpoints.finish.removeAttribute('tabindex');
		rpoints.finish.removeAttribute('aria-hidden');
		rpoints.game_board.setAttribute('aria-label','Illustration of a red car and a green car car waiting one either side of a railroad crossing. A train loaded with coal and freight cars travels along the tracks through the crossing. Buildings are seen in the distance, and a farmhouse is in the top right corner.');
		rpoints.game_board.focus();
		instructions.remove();
	}
}

const _show_message = async ()=>{
	rpoints.result.removeAttribute('aria-live');
	if(!rpoints.result.classList.contains('hidden')){
		rpoints.result.classList.add('hidden');
		await wait(250);
	}

	rpoints.result_text.innerHTML=_messages[_messages_index];

	_messages_index+=1;
	if(_messages_index>=_messages.length) _messages_index-=_messages.length;
	rpoints.result.classList.remove('hidden');
	rpoints.result.removeAttribute('aria-hidden');
	await wait(250);
	rpoints.result.setAttribute('aria-live','polite');
}

const _ext={
	show:({
		parent,
		clb
	})=>{
		parent.insertBefore(el,parent.firstChild);
		_resize();
		init(clb);
	},
	hide:()=>{
		if(el.parentNode) el.parentNode.removeChild(el);
	}
}

export default _ext;
